
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.098 1.854c.599-1.843 3.205-1.843 3.804 0l.343 1.056a2 2 0 001.902 1.382h1.11c1.938 0 2.743 2.479 1.176 3.618l-.898.652a2 2 0 00-.727 2.236l.343 1.056c.599 1.843-1.51 3.375-3.077 2.236l-.898-.652a2 2 0 00-2.352 0l-.898.652C4.36 15.23 2.25 13.697 2.85 11.854l.343-1.056a2 2 0 00-.727-2.236l-.898-.652C0 6.77.805 4.292 2.743 4.292h1.11A2 2 0 005.755 2.91l.343-1.056z","fill":"#EDC843"}})])
          )
        }
      }
    